import Aos from 'aos';
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick'

function HeroSlider() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        appendDots: dots => (
            <div style={{ bottom: "66px" }}>
                <ul className="flex justify-center gap-3">{dots}</ul>
            </div>
        ),
        customPaging: i => (
            <div className="w-[12px] h-[12px] rounded-full transition-all"></div>
        ),
        beforeChange: () => {
            // Slide change se pehle AOS refresh karo
            Aos.refresh();
        },
        afterChange: () => {
            // Slide change ke baad AOS refresh karo
            setTimeout(() => {
                Aos.refresh();
            }, 50);
        }
    };

    useEffect(() => {
        Aos.init({
            duration: 800,
            easing: "ease-out-cubic",
            once: false, // False rakho taaki har slide par animate ho
            mirror: true, // Elements viewport se bahar jaane par reset ho
        });

        // Initial refresh
        setTimeout(() => {
            Aos.refresh();
        }, 100);

        return () => {
            Aos.refresh();
        };
    }, []);

    return (
        <Slider {...settings}>
            {/* Slide 1 */}
            <div>
                <section className="hero-section relative mt-[66px] lg:mt-[72px]">
                    <div className='section-container relative'>
                        <div className="flex flex-col items-start py-[100px] lg:py-[140px]">
                            <div className='btn-header'>
                                <p>What we do</p>
                            </div>

                            <h1
                                data-aos="fade-up"
                                data-aos-delay="200"
                                className="font-neue pt-[12px] pb-[8px] max-w-[95%] lg:max-w-[846px] w-full text-[20px] sm:text-[24px] md:text-[28px] lg:text-[36px] font-[400] leading-[28px] sm:leading-[32px] md:leading-[36px] lg:leading-[49px] text-left text-white"
                            >
                            Commercial strategy for defense, technology, and industrial companies in the U.S.-India market.
                            </h1>

                            <p
                                data-aos="fade-up"
                                data-aos-delay="350"
                                className="max-w-[95%] lg:max-w-[812px] w-full font-neue font-[400] sm:font-[500] lg:font-[600] text-[12px] sm:text-[13px] md:text-[14px] lg:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[26px] lg:leading-[25px] tracking-[-0.22px] text-[#CACBD4] pb-[14px] sm:pb-[18px] lg:pb-[26px] text-left"
                            >
                            We advise companies and investors on market entry, growth, and investment between the United States and India.
                            </p>

                            <Link to='/what-we-do'>
                                <button
                                    data-aos="zoom-in"
                                    data-aos-delay="500"
                                    style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                    className="py-[10px] sm:py-[12px] lg:py-[15px] px-[24px] sm:px-[28px] lg:px-[40px] transition-all duration-500 hover:bg-white hover:text-[#BB872A] border border-[#BB872A] bg-[#BB872A] rounded-[10px] sm:rounded-[12px] font-[400] font-neue text-[12px] sm:text-[13px] lg:text-[14px] leading-[18px] sm:leading-[20px] text-left text-white"
                                >
                                    Explore what we do
                                </button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>

            {/* Slide 2 */}
            <div>
                <section className="hero-section hero-section2 relative mt-[66px] lg:mt-[72px]">
                    <div className='section-container relative'>
                        <div className="flex flex-col items-start py-[100px] lg:py-[140px]">
                            <div className='btn-header'>
                                <p>Insights</p>
                            </div>

                            <h1
                                data-aos="fade-up"
                                data-aos-delay="200"
                                className="font-neue pt-[12px] pb-[8px] max-w-[95%] lg:max-w-[846px] w-full text-[20px] sm:text-[24px] md:text-[28px] lg:text-[36px] font-[400] leading-[28px] sm:leading-[32px] md:leading-[36px] lg:leading-[49px] text-left text-white"
                            >
                            Opportunity is widening across the U.S.-India corridor.
                            </h1>

                            <p
                                data-aos="fade-up"
                                data-aos-delay="350"
                                className="max-w-[95%] lg:max-w-[812px] w-full font-neue font-[400] sm:font-[500] lg:font-[600] text-[12px] sm:text-[13px] md:text-[14px] lg:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[26px] lg:leading-[25px] tracking-[-0.22px] text-[#CACBD4] pb-[14px] sm:pb-[18px] lg:pb-[26px] text-left"
                            >
                            Access is opening in both directions. Turning it into revenue takes a clear strategy, a sound structure, and an accurate read of each market.
                            </p>

                            <Link to='/Insights'>
                                <button
                                    data-aos="zoom-in"
                                    data-aos-delay="500"
                                    style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                    className="py-[10px] sm:py-[12px] lg:py-[15px] px-[24px] sm:px-[28px] lg:px-[40px] transition-all duration-500 hover:bg-white hover:text-[#BB872A] border border-[#BB872A] bg-[#BB872A] rounded-[10px] sm:rounded-[12px] font-[400] font-neue text-[12px] sm:text-[13px] lg:text-[14px] leading-[18px] sm:leading-[20px] text-left text-white"
                                >
                                    Explore our insights
                                </button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>

            {/* Slide 3 */}
            <div>
                <section className="hero-section hero-section3 relative mt-[66px] lg:mt-[72px]">
                    <div className='section-container relative'>
                        <div className="flex flex-col items-start py-[100px] lg:py-[140px]">
                            <div className='btn-header'>
                                <p>Get in touch</p>
                            </div>

                            <h1
                                data-aos="fade-up"
                                data-aos-delay="200"
                                className="font-neue pt-[12px] pb-[8px] max-w-[95%] lg:max-w-[846px] w-full text-[20px] sm:text-[24px] md:text-[28px] lg:text-[36px] font-[400] leading-[28px] sm:leading-[32px] md:leading-[36px] lg:leading-[49px] text-left text-white"
                            >
                                We are selective about our clients and stay close to their work
                            </h1>

                            <p
                                data-aos="fade-up"
                                data-aos-delay="350"
                                className="max-w-[95%] lg:max-w-[812px] w-full font-neue font-[400] sm:font-[500] lg:font-[600] text-[12px] sm:text-[13px] md:text-[14px] lg:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[26px] lg:leading-[25px] tracking-[-0.22px] text-[#CACBD4] pb-[14px] sm:pb-[18px] lg:pb-[26px] text-left"
                            >
                            We work with companies and investors, staying with them over the long term.
                            </p>

                            <Link to='/contact-us'>
                                <button
                                    data-aos="zoom-in"
                                    data-aos-delay="500"
                                    style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                    className="py-[10px] sm:py-[12px] lg:py-[15px] px-[24px] sm:px-[28px] lg:px-[40px] transition-all duration-500 hover:bg-white hover:text-[#BB872A] border border-[#BB872A] bg-[#BB872A] rounded-[10px] sm:rounded-[12px] font-[400] font-neue text-[12px] sm:text-[13px] lg:text-[14px] leading-[18px] sm:leading-[20px] text-left text-white"
                                >
                                    Contact us
                                </button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </Slider>
    )
}

export default HeroSlider;